export const queue = {
  input: {
    timeout: {
      label: 'Bataswaktu Queue'
    },

    type: {
      label: 'Metode Distribusi'
    },

    contact_methods: {
      label: 'Metode Kontak'
    },

    contact_groups: {
      label: 'Kelompok'
    }
  },

  state: {
    init: {
      description:
        'Queue - elemen skema, yang berfungsi untuk mentransfer panggilan ke operator. Panggilan yang belum diterima untuk pekerjaan akan pergi ke cabang terpisah dalam skema - batas waktu.'
    },
    add_group: {
      title: 'Tambah kelompok ke queue'
    },

    ['add-method']: {
      title: 'Add contact method to the queue',
      description: `Anda dapat menambahkan metode kontak dan grup baru di akun pribadi Anda, in the`
    }
  }
};
